import { render } from "./index.vue?vue&type=template&id=71db2dfb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=71db2dfb&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71db2dfb"],['__file',"src/views/other/workflow/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71db2dfb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71db2dfb', __exports__)) {
    console.log('reload')
    api.reload('71db2dfb', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=71db2dfb&scoped=true", () => {
    console.log('re-render')
    api.rerender('71db2dfb', render)
  })

}


export default __exports__